import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
//import store from './store'

import PrimeVue from 'primevue/config';
import '/node_modules/primeflex/primeflex.css'
import 'primevue/resources/themes/md-light-indigo/theme.css'
import 'primevue/resources/primevue.min.css'; // Core styles
import 'primeicons/primeicons.css'; // Icons

import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import DataTable from "primevue/datatable";
//import Row from 'primevue/row';             
import PrimevueButton from "primevue/button";
import Ripple from "primevue/ripple";
import StyleClass from "primevue/styleclass";
import mitt from "mitt"
import Tooltip from 'primevue/tooltip';
import ConfirmDialog from 'primevue/confirmdialog';
//import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmationService from 'primevue/confirmationservice';
import PrimevueEditor from 'primevue/editor';

export const emiter = mitt()

const app = createApp(App);
app.use(router);
app.use(PrimeVue);
app.use(ConfirmationService);
app.directive('ripple', Ripple);
app.directive('styleclass', StyleClass);
app.directive('tooltip', Tooltip);
app.component('PrimevueButton', PrimevueButton);
app.component('InputText', InputText);
app.component('InputNumber', InputNumber);
app.component('DataTable', DataTable);
app.component('ConfirmDialog', ConfirmDialog);
app.component('PrimevueEditor', PrimevueEditor);

app.mount('#app')

setInterval(() => {
    emiter.emit('reload');
}, 60000);

